
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/live/[roomId]",
      function () {
        return require("private-next-pages/live/[roomId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/live/[roomId]"])
      });
    }
  